export default __webpack_public_path__ + "static/media/shop.48d4337e.png";